import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { CardiometabolicOmega3DiagramContent } from "./CardiometabolicOmega3Diagram";
import { CardiometabolicOmega3KeyContent } from "./CardiometabolicOmega3Key";

const SvgCardiometabolicOmega3DiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1240, 1456)}
      viewBox={diagramOnly ? "0 142 1024 1240" : "0 0 1024 1456"}
    >
      <g id="cardiometabolic-omega3-diagram+key" clipPath="url(#clip0_18293_231785)">
        <rect width={1024} height={diagramOnly ? 1240 : 1456} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <CardiometabolicOmega3KeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <CardiometabolicOmega3DiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_231785">
          <rect width={1024} height={1456} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_231785">
          <rect width={1024} height={1240} fill="white" transform="translate(0 142)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCardiometabolicOmega3DiagramKey;
